<template>
  <div class="pt-card-attribute switch">
    <r-text style="margin-bottom: 8px;" type="caption">
      {{ config.label }}
    </r-text>
    <div class="pt-card-attribute-content">
      <el-switch class="r-switch" v-model="feature[config.prop]" />
      <r-text @click.native="feature[config.prop] = !feature[config.prop]">
        {{ feature[config.prop] ? config.labelTrue : config.labelFalse }}
      </r-text>
    </div>
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style lang="scss">
.pt-card-attribute.switch {
  .pt-card-attribute-content {
    display: flex;
    align-items: center;

    .r-text {
      cursor: pointer;
      margin-left: 8px;
    }
  }
}
</style>
